import { Vue, Component, Prop } from 'vue-property-decorator';
import CollectionCard from '../collection-card/collection-card';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import UnitCard from '../unit-card/unit-card';
import LessonCard from '../lesson-card/lesson-card';
import ResourceCard from '../resource-card/resource-card';
import CourseCard from '../course-card/course-card';
import QuestionCard from '../question-card/question-card';
import AssessmentCard from '../assessment-card/assessment-card';
import OfflineActivityCard from '../offline-activity-card/offline-activity-card';
import { searchAPI } from '@/providers/apis/search/search';

@Component({
    name: 'learning-map-content',
    components: {
        'collection-card': CollectionCard,
        'material-icon': GoogleMaterialIcon,
        'unit-card': UnitCard,
        'lesson-card': LessonCard,
        'resource-card': ResourceCard,
        'course-card': CourseCard,
        'question-card': QuestionCard,
        'assessment-card': AssessmentCard,
        'offline-activity': OfflineActivityCard,
    },
})

export default class LearningMapContent extends Vue {
    // -----------------------------------------------------------------------------
    // Properties
    @Prop()
    private learningMapContent: any;

    @Prop()
    private selectedContent: any;

    @Prop()
    private gutCode: any;

    private pageNum: any = 1;

    get selectedContentList() {
        return this.learningMapContent ?
            this.learningMapContent[this.selectedContent] : [];
    }

    get totalCount() {
        return this.learningMapContent ?
            this.learningMapContent.totalCounts[this.selectedContent] : 0;
    }

    // -------------------------------------------------------------------------------
    // Actions

    private onClose() {
        this.$emit('onClose');
    }

    private async showMore(more: any) {
        const searchedFor = this.selectedContent;
        this.pageNum = this.pageNum + more;
        const params: any = {
            gutCodes: [this.gutCode],
            includeContentTypes: [this.selectedContent],
            languageId : 1,
        };
        const pagination = {
            limit: 5,
            pageNum: this.pageNum,
        };

        const searchData: any = await searchAPI.searchCapLearnerContents(params, pagination);
        for (const data of searchData[searchedFor]) {
            this.learningMapContent[searchedFor].push(data);
        }
    }
}
